import React from "react";
import { DeltaBattleScreen } from "./DeltaBattleScreen";

export const DeltaPlayer2GameScreen = (props) => (
    <DeltaBattleScreen
        {...props}
        characterName="Драсерг"
        attackSignal="draserg_attack"
        healSignal="draserg_heal"
        attackDescription="Три кинжала летят в сторону души. Урон 10."
        healDescription="Конфеты появляются по всему полю. Лечение 4."
    />
);
